import { slugify } from './strings.js';
import type AltenarSportsbook from '@/shared/SportsBook/AltenarSportsbook/types.d.ts';

export function makeUrl(
  ...args: (string | number | undefined | null)[]
): string {
  const hasLeadingSlash =
    typeof args[0] === 'string' && args[0].startsWith('/');

  const slugified: string[] = [];

  for (const arg of args) {
    const slug = slugify(arg);

    if (slug) {
      slugified.push(slug);
    }
  }

  const url = slugified.join('/');

  return hasLeadingSlash ? `/${url}` : url;
}

export function getDataFromUrl(path: string) {
  const lastPart = (path || '').split('/').pop() || '';
  const splittedData = lastPart.split('-');

  return {
    prefix: splittedData[0] || '',
    id: Number(splittedData[1] || ''),
    suffix: splittedData[2] || '',
  };
}

export function getDataFromLocation(to: AltenarSportsbook.PathEntry) {
  if (!to) {
    return {};
  }

  const sportId = to.sport?.id || to.sportId || '';
  const sportName = to.sport?.name || '';

  const firstCategory = to.categories?.[0];
  const categoryId = firstCategory?.id || to.categoryIds?.[0] || '';
  const categoryName = firstCategory?.name || '';

  const firstChampionship = to.championships?.[0];
  const championshipId = firstChampionship?.id || to.championshipIds?.[0] || '';
  const championshipName = firstChampionship?.name || '';

  const eventId = to.event?.id || to.eventId || '';
  const eventName = to.event?.name || '';

  return {
    categoryId,
    categoryName,
    sportId,
    sportName,
    eventId,
    eventName,
    championshipId,
    championshipName,
  };
}
